import './index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useCallback, useRef } from 'react';
import { Selection } from '@hh.ru/magritte-common-text-selection';
import { useMultipleRefs } from '@hh.ru/magritte-common-use-multiple-refs';
import { EyeCrossedOutlinedSize16, EyeOutlinedSize16, EyeCrossedOutlinedSize24, EyeOutlinedSize24 } from '@hh.ru/magritte-ui-icon/icon';
import { Input } from './Input.js';
import './BaseInput.js';
import 'classnames';
import '@hh.ru/magritte-common-mouse';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-action';
import '@hh.ru/magritte-ui-form-helper';
import './useFocus.js';
import './useInputAriaProps.js';
import '@hh.ru/magritte-ui-typography';

const PasswordInput = forwardRef(({ onFocus, size, ...props }, ref) => {
    const [typePassword, setTypePassword] = useState(true);
    const clickHandler = useCallback(() => {
        setTypePassword((typePassword) => !typePassword);
    }, [setTypePassword]);
    const inputRef = useRef(null);
    const inputRefCallback = useMultipleRefs(ref, inputRef);
    const focusHandler = useCallback((event) => {
        if (inputRef.current) {
            Selection.set(inputRef.current, 0, inputRef.current.value.length, 'forward');
        }
        onFocus && onFocus(event);
    }, [onFocus, inputRef]);
    return (jsx(Input, { ...props, size: size, buttonIcon: size === 'small'
            ? (typePassword && EyeCrossedOutlinedSize16) || EyeOutlinedSize16
            : (typePassword && EyeCrossedOutlinedSize24) || EyeOutlinedSize24, buttonDataQa: "password-visibility-switch-button", onFocus: focusHandler, type: typePassword ? 'password' : 'text', onButtonClick: clickHandler, ref: inputRefCallback }));
});
PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
//# sourceMappingURL=PasswordInput.js.map
